module.exports = "<app-header></app-header>\n<router-outlet></router-outlet>\n<app-footer *ngIf=\"router.url !== '/signin'\"></app-footer>\n\n"